import EventBus from "../events/EventBus";
import initClickToCopy from "./click_to_copy";
import { Tooltip } from "./tooltips";
export default function initCouponsModal() {
    EventBus.on('modal:open', function (modal) {
        if (modal.id !== 'modal-coupons-info' && !modal.querySelector('.copy-click')) {
            return;
        }
        initClickToCopy('.copy-click');
        var wrapper = modal.querySelector('.modal__wrapper') || modal;
        modal.querySelectorAll('.tooltip-btn')
            .forEach(function (button) {
            var _a;
            var tooltip = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.tooltip');
            if (!tooltip) {
                return;
            }
            // Переносим tooltip в .modal__wrapper, чтобы он не ограничивался .modal__main
            if (tooltip.parentElement !== wrapper) {
                wrapper.appendChild(tooltip);
            }
            new Tooltip(button, tooltip).attachHoverEvents();
        });
    });
}
